import { ContentEmpty } from "@inductiveautomation/ws-components";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { format } from "date-fns";
import { getCurrentActions } from "../Training.actionsForState";
import {
  Certification,
  CertificationActionCallback,
  ElectiveWithType,
} from "../Training.types";

const heading = (t: TFunction, certification: Certification) => {
  if (certification.type === "GOLD") {
    return certification.earnMethod === "TEST"
      ? t("training.gold.in_progress_test.heading")
      : t("training.gold.in_progress_course.heading");
  } else if (certification.type === "CORE") {
    return certification.earnMethod === "TEST"
      ? t("training.core.in_progress_test.heading")
      : t("training.core.in_progress_course.heading");
  }

  return "";
};

const description = (t: TFunction, certification: Certification) => {
  if (certification.type === "GOLD" && certification.testDeadline) {
    const testDeadline = new Date(certification.testDeadline);
    const date = format(testDeadline, "MMMM d, yyyy");
    const time = format(testDeadline, "kk:mm");

    return certification.earnMethod === "TEST"
      ? t(`training.gold.in_progress_test.description`, {
          date,
          time,
        })
      : t("training.gold.in_progress_course.description");
  } else if (certification.type === "CORE" && certification.testDeadline) {
    const testDeadline = new Date(certification.testDeadline);
    const date = format(testDeadline, "MMMM d, yyyy");
    const time = format(testDeadline, "kk:mm");

    return certification.earnMethod === "TEST"
      ? t("training.core.in_progress_test.description", { date, time })
      : t("training.core.in_progress_course.description");
  }

  return "";
};

const InProgressContent = ({
  certification,
  onAction,
}: {
  certification: Exclude<Certification, ElectiveWithType>;
  onAction: CertificationActionCallback;
}) => {
  const { t } = useTranslation();

  return (
    <ContentEmpty
      icon="certification"
      heading={heading(t, certification)}
      description={description(t, certification)}
      actions={getCurrentActions(t, onAction, certification)
        .flat()
        .map((action) => ({
          ...action,
          onClick: () => action.onClick(action.id, []),
        }))}
    />
  );
};

export default InProgressContent;
